<template>
  <div class="register-wrap">
    <oem-token-site-info :oem-token="$route.params.oem_token" @updateSiteInfo="updateSiteInfo" />
    <authLeft v-if="$mq != 'sp' && $mq != 'tb'" />
    <div class="register-right">
      <div class="register-form">
        <el-form :model="form" :rules="rules" ref="form" @submit.native.prevent="register">
          <div class="register-form-title" style="margin-bottom:10px">
            {{ siteName }} アカウント登録
          </div>
          <div class="register-form-subtitle" style="margin-bottom:30px">初回のご登録から7日間無料でご利用いただけます。</div>
          <div class="register-form-subtitle">企業名<span style="color:red; margin-left:3px">*</span></div>
          <el-form-item prop="client_name">
            <el-input size="small" placeholder="企業名" v-model="form.client_name"></el-input>
          </el-form-item>
          <div class="register-form-subtitle">企業種別<span style="color:red; margin-left:3px">*</span></div>
          <el-form-item prop="client_type">
            <el-select size="small" v-model="form.client_type" placeholder="業種を選択してください">
              <el-option label="広告会社/広告代理店" value="広告会社/広告代理店"></el-option>
              <el-option label="PR/マーケティング会社" value="PR/マーケティング会社"></el-option>
              <el-option label="広告主" value="広告主"></el-option>
              <el-option label="芸能事務所" value="芸能事務所"></el-option>
              <el-option label="その他" value="その他"></el-option>
            </el-select>
          </el-form-item>
          <div class="register-form-subtitle">担当者名<span style="color:red; margin-left:3px">*</span></div>
          <el-form-item prop="person_name">
            <el-input size="small" placeholder="担当者名" v-model="form.person_name"></el-input>
          </el-form-item>
          <div class="register-form-subtitle">担当部署<span style="color:red; margin-left:3px">*</span></div>
          <el-form-item prop="department">
            <el-input size="small" placeholder="担当部署" v-model="form.department"></el-input>
          </el-form-item>
          <div class="register-form-subtitle">メールアドレス<span style="color:red; margin-left:3px">*</span></div>
          <el-form-item prop="email">
            <el-input size="small" placeholder="メールアドレス" v-model="form.email"></el-input>
          </el-form-item>
          <div class="register-form-subtitle">担当者電話番号<span style="color:red; margin-left:3px">*</span></div>
          <el-form-item prop="tel">
            <el-input size="small" placeholder="電話番号" v-model="form.tel" autocomplete="off"></el-input>
          </el-form-item>
          <div class="register-form-subtitle">パスワード<span style="color:red; margin-left:3px">*</span></div>
          <el-form-item prop="pass">
            <el-input size="small" placeholder="パスワード" v-model="form.pass" type="password" autocomplete="new-password"></el-input>
          </el-form-item>
          <div class="register-form-subtitle">パスワード(再入力)<span style="color:red; margin-left:3px">*</span></div>
          <el-form-item prop="checkPass">
            <el-input size="small" placeholder="パスワード(再入力)" v-model="form.checkPass" type="password" autocomplete="off"></el-input>
          </el-form-item>
          <el-button style="width:100%; margin-top:10px;" type="primary" native-type="submit" :disabled="!consent || loading">
            <div class="flex-row">
              アカウント登録
              <div class="loader--mini" v-show="loading"></div>
            </div>
          </el-button>
          <div class="register-form-subtitle bottom">
            <el-checkbox v-model="consent"></el-checkbox>
            <span style="margin-left:10px; font-size:11px; color:#999">
              <a :href=termsOfUseUrl target="_blank" style="color:#0095f6">利用規約</a>
              に同意して登録する</span
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import authLeft from "./auth_left";
import OemTokenSiteInfo from "../oem/OemTokenSiteInfo.vue";

var freeEmail =
  // "/@msn.com$|@gmail.com$|@hotmail.co.jp$|@hotmail.com$|@yahoo.co.jp$|@mail.goo.ne.jp$|@freemail.ne.jp$|@tokyo24.com$|@excite.co.jp$|@infoseek.co.jp$|@infoseek.jp$|@comeon.to$|@comeon.cx$|@cuib.or.jp$|@ziplip.co.jp$|@zdnetmail.ne.jp$|@supermail.com$|@lycos.ne.jp$|@lycos.com$|@clubaa.com$|@prontomail.ne.jp$|@itpmail.itp.ne.jp$|@bizoffi.com$|@xaque.com$|@safe-mail.ne.jp$|@100100.co.jp$|@mailkun.com$|@curio-city.com$|@teamgear.net$|@24h.co.jp$|@gariya.net$|@pub.ne.jp$|@jmail.co.jp$|@kigaru.zzn.com$|@goomail.com$|@iloveyou-jp.com$|@wbs-club.ne.jp$|@otegami.com$|@piyomail.com$|@iat.ne.jp$|@aol.com$|@tok2.com$|@kobe-city.com$|@xmail.to$|@club.wonder.ne.jp$|@pub.to$|@csc.ne.jp$|@club.ne.jp$|@mcn.ne.jp$|@postpet.co.jp$|@manbow.com$|@ijk.com$|@drive.co.jp$|@yagi.net$|@pospe.jp.prg$|@estyle.ne.jp$|@eastmail.com$|@shagami.com$|@voo.to$|@julex.to$|@yi-web.com$|@mailfriend.net$|@koei.nu$|@goo.jp$|@kobej.zzn.com$|@pc_run.zzn.com$|@fact-mail.com$|@walkerplus.com$|@keyakiclub.net$|@yesyes.jp$|@fubako.com$|@smoug.net$|@meritmail.net$|@vjp.jp$|@melmel.tv$|@ultrapostman.com$|@uymail.com$|@sailormoon.com$|@astroboymail.com$|@doramail.com$|@dbzmail.com$|@aamail.jp$|@lunashine.net$|@gooo.jp$|@1kw.jp$|@hsjp.net$|@glaystyle.net$|@saku2.com$|@kyouin.com$|@Netidol.jp$|@csc.jp$|@kanagawa.to$|@mukae.com$|@anet.ne.jp$|@docomo.ne.jp$|@softbank.ne.jp$|@i.softbank.jp$|@disney.ne.jp$|@d.vodafone.ne.jp$|@h.vodafone.ne.jp$|@t.vodafone.ne.jp$|@c.vodafone.ne.jp$|@r.vodafone.ne.jp$|@k.vodafone.ne.jp$|@n.vodafone.ne.jp$|@s.vodafone.ne.jp$|@q.vodafone.ne.jp$|@jp-d.ne.jp$|@jp-h.ne.jp$|@jp-t.ne.jp$|@jp-c.ne.jp$|@jp-c.ne.jp$|@jp-k.ne.jp$|@jp-n.ne.jp$|@jp-s.ne.jp$|@jp-q.ne.jp$|@ezweb.ne.jp$|@au.com$|@biz.ezweb.ne.jp$|@ido.ne.jp$|@sky.tkk.ne.jp$|@sky.tkc.ne.jp$|@sky.tu-ka.ne.jp$|@pdx.ne.jp$|@di.pdx.ne.jp$|@dj.pdx.ne.jp$|@dk.pdx.ne.jp$|@wm.pdx.ne.jp$|@willcom.com$|@emnet.ne.jp$/";
  "/@msn.com$|@hotmail.co.jp$|@hotmail.com$|@yahoo.co.jp$|@mail.goo.ne.jp$|@freemail.ne.jp$|@tokyo24.com$|@excite.co.jp$|@infoseek.co.jp$|@infoseek.jp$|@comeon.to$|@comeon.cx$|@cuib.or.jp$|@ziplip.co.jp$|@zdnetmail.ne.jp$|@supermail.com$|@lycos.ne.jp$|@lycos.com$|@clubaa.com$|@prontomail.ne.jp$|@itpmail.itp.ne.jp$|@bizoffi.com$|@xaque.com$|@safe-mail.ne.jp$|@100100.co.jp$|@mailkun.com$|@curio-city.com$|@teamgear.net$|@24h.co.jp$|@gariya.net$|@pub.ne.jp$|@jmail.co.jp$|@kigaru.zzn.com$|@goomail.com$|@iloveyou-jp.com$|@wbs-club.ne.jp$|@otegami.com$|@piyomail.com$|@iat.ne.jp$|@aol.com$|@tok2.com$|@kobe-city.com$|@xmail.to$|@club.wonder.ne.jp$|@pub.to$|@csc.ne.jp$|@club.ne.jp$|@mcn.ne.jp$|@postpet.co.jp$|@manbow.com$|@ijk.com$|@drive.co.jp$|@yagi.net$|@pospe.jp.prg$|@estyle.ne.jp$|@eastmail.com$|@shagami.com$|@voo.to$|@julex.to$|@yi-web.com$|@mailfriend.net$|@koei.nu$|@goo.jp$|@kobej.zzn.com$|@pc_run.zzn.com$|@fact-mail.com$|@walkerplus.com$|@keyakiclub.net$|@yesyes.jp$|@fubako.com$|@smoug.net$|@meritmail.net$|@vjp.jp$|@melmel.tv$|@ultrapostman.com$|@uymail.com$|@sailormoon.com$|@astroboymail.com$|@doramail.com$|@dbzmail.com$|@aamail.jp$|@lunashine.net$|@gooo.jp$|@1kw.jp$|@hsjp.net$|@glaystyle.net$|@saku2.com$|@kyouin.com$|@Netidol.jp$|@csc.jp$|@kanagawa.to$|@mukae.com$|@anet.ne.jp$|@docomo.ne.jp$|@softbank.ne.jp$|@i.softbank.jp$|@disney.ne.jp$|@d.vodafone.ne.jp$|@h.vodafone.ne.jp$|@t.vodafone.ne.jp$|@c.vodafone.ne.jp$|@r.vodafone.ne.jp$|@k.vodafone.ne.jp$|@n.vodafone.ne.jp$|@s.vodafone.ne.jp$|@q.vodafone.ne.jp$|@jp-d.ne.jp$|@jp-h.ne.jp$|@jp-t.ne.jp$|@jp-c.ne.jp$|@jp-c.ne.jp$|@jp-k.ne.jp$|@jp-n.ne.jp$|@jp-s.ne.jp$|@jp-q.ne.jp$|@ezweb.ne.jp$|@au.com$|@biz.ezweb.ne.jp$|@ido.ne.jp$|@sky.tkk.ne.jp$|@sky.tkc.ne.jp$|@sky.tu-ka.ne.jp$|@pdx.ne.jp$|@di.pdx.ne.jp$|@dj.pdx.ne.jp$|@dk.pdx.ne.jp$|@wm.pdx.ne.jp$|@willcom.com$|@emnet.ne.jp$/";

const root = process.env.VUE_APP_API;
const authAPI = root + "/api/auth/auth";
const readContactAPI = root + "/api/auth/read_contact";
const emailValidateAPI = root + "/api/auth/emailvalidate";

export default {
  name: "register",
  components: {
    authLeft,
    OemTokenSiteInfo,
  },
  provide() {
    return {
      updateSiteInfo: this.updateSiteInfo
    }
  },
  data() {
    var validateEmail = (rule, value, callback) => {
      var freeCheck = value.match(freeEmail);
      if (freeCheck) {
        // callback();
        callback(new Error("フリーアドレスはご利用いただけません"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワードは必須です"));
      } else {
        if (this.form.checkPass !== "") {
          this.$refs.form.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("パスワード(再入力)は必須です"));
      } else if (value !== this.form.pass) {
        callback(new Error("パスワードが一致しません"));
      } else {
        callback();
      }
    };
    return {
      consent: false,
      form: {
        client_name: "",
        person_name: "",
        department: "",
        email: "",
        tel: "",
        pass: "",
        checkPass: "",
      },
      loading: false,
      rules: {
        client_name: [{ required: true, message: "企業名は必須です", trigger: "change" }],
        client_type: [{ required: true, message: "業種は必須です", trigger: "change" }],
        person_name: [{ required: true, message: "担当者名は必須です", trigger: "change" }],
        department: [{ required: true, message: "担当部署は必須です", trigger: "change" }],
        email: [
          {
            required: true,
            message: "メールアドレスは必須です",
            trigger: "change",
          },
          { validator: validateEmail, trigger: "change" },
        ],
        tel: [
          { required: true, message: "電話番号は必須です", trigger: "change" },
          {
            min: 9,
            message: "正しい電話番号を入力してください",
            trigger: "change",
          },
        ],
        pass: [
          {
            required: true,
            message: "パスワードは必須です",
            trigger: "change",
          },
          {
            min: 8,
            message: "パスワードは8文字以上で設定してください",
            trigger: "change",
          },
          { validator: validatePass, trigger: "change" },
        ],
        checkPass: [{ validator: validatePass2, trigger: "change" }],
      },
      siteName: "REECH DATABASE",
      termsOfUseUrl: "https://reech.co.jp/term/",
    };
  },
  mounted() {
    this.readContact();
  },
  methods: {
    readContact() {
      var id = this.$route.query.id;
      var email = this.$route.query.email;
      var oem_token = this.$route.params.oem_token;
      if (id && email) {
        var params = {
          id: id,
          email: email
        };
        if (oem_token) {
          params.oem_token = oem_token;
        }
        this.axios
            .get(readContactAPI, { params: params })
            .then((response) => {
              this.form.client_name = response.data.client_name;
              this.form.person_name = response.data.person_name;
              this.form.email = response.data.email;
              this.form.tel = response.data.tel;
            })
            .catch(() => {});
      }
    },
    register() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loading = true;
          var params = new URLSearchParams();
          params.append("email", this.form.email);
          params.append("type", "register");
          if (this.$route.params.oem_token) {
            params.append("oem_token", this.$route.params.oem_token);
          }
          this.axios.post(emailValidateAPI, params).then((response) => {
            if (response.data.status == "NG") {
              this.loading = false;
              this.$message.error(response.data.message);
            } else {
              firebase
                .auth()
                .createUserWithEmailAndPassword(this.form.email, this.form.pass)
                .then((authData) => {
                  var params = new URLSearchParams();
                  params.append("client_name", this.form.client_name);
                  params.append("client_type", this.form.client_type);
                  params.append("person_name", this.form.person_name);
                  params.append("department", this.form.department);
                  params.append("email", this.form.email);
                  params.append("tel", this.form.tel);
                  params.append("pass", this.form.pass);
                  params.append("uid", authData.user.uid);
                  if (this.$route.params.oem_token) {
                    params.append("oem_token", this.$route.params.oem_token);
                  }
                  this.axios.post(authAPI, params).then((response) => {
                    if (response.data.status == "OK") {
                      var params = new URLSearchParams();
                      params.append("user_token", authData.user.uid);
                      if (this.$route.params.oem_token) {
                        params.append("oem_token", this.$route.params.oem_token);
                      }
                      this.$router.push({
                        path: "/confirm",
                        query: {
                          token: authData.user.uid,
                          oem_token: this.$route.params.oem_token
                        },
                      });
                    } else {
                      this.$message({
                        type: "error",
                        offset: 7,
                        showClose: true,
                        message: "エラーが発生しました。しばらく時間を空けてお試しいただくか、担当者までご連絡ください。",
                      });
                      this.loading = false;}
                  });
                })
                .catch(() => {
                  this.$message.error("既に登録されているメールアドレスです");
                  this.loading = false;
                });
            }
          });
        } else {
          this.$message.error("項目を正しく入力してください");
          this.loading = false;
        }
      });
    },
    updateSiteInfo({siteName, termsOfUseUrl}) {
      this.siteName = siteName;
      this.termsOfUseUrl = termsOfUseUrl;
    },
  },
  watch: {},
};
</script>
